// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const HymerTheme = props => {
    useThemeStylesheet(() => import("./hymer.lazy.scss"));
    return <>
	<ContrastColorUpdater/>
	{props.children}
    </>;
};

export default HymerTheme;
